import React, { useState, useEffect } from 'react';
import DisplayAd from './DisplayAd';
import { usePremium } from '../../context/PremiumContext';

const SidebarAd = ({ side = 'left' }) => {
    const { isPremium } = usePremium();
    const [adAllowed, setAdAllowed] = useState(false);

    // Don't render ads for premium users
    if (isPremium) return null;
    useEffect(() => {
        const checkConsent = () => {
            const consent = localStorage.getItem('gymtracker_cookie_consent');
            if (consent === 'all') return true;
            try {
                const parsed = JSON.parse(consent);
                return parsed && parsed.marketing === true;
            } catch {
                return false;
            }
        };

        setAdAllowed(checkConsent());

        const handleConsentChange = () => setAdAllowed(checkConsent());
        window.addEventListener('cookieConsentChanged', handleConsentChange);
        return () => window.removeEventListener('cookieConsentChanged', handleConsentChange);
    }, []);

    // Don't render anything if ads not allowed (except on localhost for preview)
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname.includes('localhost');
    if (!adAllowed && !isLocalhost) return null;

    return (
        <div
            className={`
                hidden 2xl:block fixed top-1/2 -translate-y-1/2 z-0
                ${side === 'left' ? 'left-4' : 'right-4'}
                pointer-events-auto
            `}
        >
            <div className="w-[160px] flex flex-col items-center">
                <span className="text-[10px] text-neutral-600 font-bold uppercase tracking-widest mb-2 vertical-text">
                    Advertisement
                </span>
                <DisplayAd format="vertical" className="my-0" />
            </div>

            <style>{`
                .vertical-text {
                    writing-mode: vertical-rl;
                    text-orientation: mixed;
                    transform: rotate(180deg);
                }
            `}</style>
        </div>
    );
};

export default SidebarAd;
